import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./Navbar.css";

import unity from "../../../assets/logo/unity.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import api from "../../../api/axios";
import { useSettings } from "../../../context/SettingsContext";
import { useDispatch } from "react-redux";
import { logout } from "../../../redux/slices/authSlice";
import { readStoredJson } from "../../../utilities/session";

const Navbar = () => {
  const { globalSettings } = useSettings();

  const [mobileMenu, setMobileMenu] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);

  const dropdownRef = useRef(null);
  const aboutRef = useRef(null);
  const profileRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const user =
    location.state?.user || readStoredJson("user", null);
  const googleUser = readStoredJson("googleUser", null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesDropdown(false);
      }
      if (aboutRef.current && !aboutRef.current.contains(e.target)) {
        setAboutDropdown(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    dispatch(logout()); // clears the stored session too
    navigate("/", { replace: true });
    window.location.reload();
  };

  const closeAllMenus = () => {
    setMobileMenu(false);
    setServicesDropdown(false);
    setAboutDropdown(false);
  };

  const avatarSrc = user?.profile_photo_path
    ? `${api.defaults.baseURL}/${user.profile_photo_path}`
    : googleUser?.picture
      ? googleUser.picture
      : "/assets/images/users/avatar-1.jpg";

  const aboutSubmenu = [
    { title: "About Us", path: "/about-us" },
    { title: "OUR STORY", path: "/about-us/our-story" },
    { title: "Mission & Vision", path: "/about-us/mission-vision" },
    { title: "Our Core Values", path: "/about-us/our-core-values" },
    { title: "Executive Committee", path: "/about-us/executive-committee" },
    { title: "All Directors", path: "/about-us/all-directors" },
    { title: "Why Choose Us", path: "/about-us/why-choose-us" },
    { title: "Testimonials", path: "/about-us/testimonials" },
    { title: "FAQ", path: "/faq" },
  ];

  return (
    <div className="new-nav-conatainer">
      <nav className="navbar">
        <div className="navbar-content">
          {/* Logo */}
          <div className="nav-logo">
            <Link to="/" onClick={closeAllMenus}>
              <img
                src={globalSettings?.logo ? globalSettings.logo : unity}
                alt="Company Logo"
              />
            </Link>
          </div>

          {/* Mobile icon (guest) */}
          {!user && !googleUser && (
            <div
              className="mobile-icon"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {mobileMenu ? <FaTimes size={24} /> : <FaBars size={24} />}
            </div>
          )}

          {/* Navigation */}
          <ul className={`nav-links ${mobileMenu ? "active" : ""}`}>
            <li>
              <NavLink to="/" onClick={closeAllMenus}>
                HOME
              </NavLink>
            </li>

            {/* ABOUT */}
            <li
              className="dropdown"
              ref={aboutRef}
              onMouseEnter={() =>
                window.innerWidth > 992 && setAboutDropdown(true)
              }
              onMouseLeave={() =>
                window.innerWidth > 992 && setAboutDropdown(false)
              }
            >
              <button
                type="button"
                className="dropdown-trigger nav-link-button"
                onClick={() => setAboutDropdown(!aboutDropdown)}
              >
                ABOUT <MdKeyboardArrowDown className="arrow-icon" />
              </button>

              <div
                className={`dropdown-menu dropdown-container ${
                  aboutDropdown ? "show" : ""
                }`}
              >
                {aboutSubmenu.map((item, index) => (
                  <Link key={index} to={item.path} onClick={closeAllMenus}>
                    {item.title}
                  </Link>
                ))}
              </div>
            </li>

            {/* SISTER CONCERN */}
            <li
              className="dropdown"
              ref={dropdownRef}
              onMouseEnter={() =>
                window.innerWidth > 992 && setServicesDropdown(true)
              }
              onMouseLeave={() =>
                window.innerWidth > 992 && setServicesDropdown(false)
              }
            >
              <button
                type="button"
                className="dropdown-trigger nav-link-button"
                onClick={() => setServicesDropdown(!servicesDropdown)}
              >
                SISTER CONCERN <MdKeyboardArrowDown className="arrow-icon" />
              </button>

              <div
                id="sister-dropdown"
                className={`dropdown-menu dropdown-container ${
                  servicesDropdown ? "show" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicexpressbd.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span
                    style={{ color: "#94a3b8", transition: "color 0.2s ease" }}
                  >
                    01.{" "}
                  </span>{" "}
                  ICONIC EXPRESS
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconictransportbd.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>02. </span> ICONIC TRASPORT
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicdigitalsolution.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>03. </span> ICONIC DIGITAL
                  SOLUTIONS
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicglobaltravels.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>04. </span> ICONIC GLOBAL
                  TRAVELS LTD
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicgreenland.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>05. </span> ICONIC
                  GREENLAND
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconichajjgroup.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>06. </span> ICONIC HAJJ
                  GROUP
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicmotorsltd.com", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>07. </span> ICONIC MOTORS
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicshikhon.com", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>08. </span> ICONIC SHIKHON
                </Link>

                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicsoftltd.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>09. </span> ICONIC SOFT LTD
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicfurniturebd.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>10. </span> ICONIC
                  FURNITURE LTD
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicholidaysbd.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>11. </span> ICONIC HOLIDAYS
                </Link>

                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://bdiconicksa.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>12. </span> BD ICONIC KSA
                </Link>

                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconictracker.com/", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>13. </span> ICONIC TRACKER
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open("https://iconicsupershop.com", "_blank", "noopener,noreferrer");
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>14. </span> ICONIC SUPER
                  SHOP
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    // No site yet: keep the entry but do not open a blank tab.
                    e.preventDefault();
                  }}
                >
                  <span style={{ color: "#94a3b8" }}>15. </span> ICONIC MALAYSIA
                </Link>
              </div>
            </li>

            <li>
              <NavLink to="/gallery" onClick={closeAllMenus}>
                GALLERY
              </NavLink>
            </li>

            <li>
              <NavLink to="/blogs" onClick={closeAllMenus}>
                BLOGS
              </NavLink>
            </li>

            <li>
              <NavLink to="/faq" onClick={closeAllMenus}>
                FAQ
              </NavLink>
            </li>

            <li>
              <NavLink to="/contact-us" onClick={closeAllMenus}>
                CONTACT
              </NavLink>
            </li>

            {/* Mobile auth */}
            {!user && !googleUser && (
              <li className="auth-buttons-mobile-wrap">
                <div className="auth-buttons auth-buttons-mobile">
                  <Link
                    to="/login"
                    className="login-button"
                    onClick={closeAllMenus}
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="register-button"
                    onClick={closeAllMenus}
                  >
                    Register
                  </Link>
                </div>
              </li>
            )}
          </ul>

          {/* User Profile */}
          {user || googleUser ? (
            <div className="topbar-action-item" ref={profileRef}>
              <div
                className="mobile-icon"
                onClick={() => setMobileMenu(!mobileMenu)}
              >
                {mobileMenu ? <FaTimes size={24} /> : <FaBars size={24} />}
              </div>

              <div
                className="user-info"
                onClick={() => setProfileDropdown(!profileDropdown)}
              >
                <img src={avatarSrc} alt="user" className="nav-avatar" />
                <div className="user-details">
                  <span className="user-name">
                    {user?.name || googleUser?.name || "User"}
                  </span>
                  <span className="user-role">{user?.mobile_number}</span>
                </div>
              </div>

              <div
                className={`dropdown-menu profile-menu-new ${
                  profileDropdown ? "show" : ""
                }`}
              >
                <div className="dropdown-header">
                  Welcome {user?.name || googleUser?.given_name}!
                </div>
                <Link to="/profile" className="dropdown-item">
                  My Account
                </Link>
                <Link to="/system-settings" className="dropdown-item">
                  Settings
                </Link>
                <div className="dropdown-divider"></div>
                <div
                  className="dropdown-item text-danger"
                  onClick={handleLogout}
                >
                  Logout
                </div>
              </div>
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="login-button">
                Login
              </Link>
              <Link to="/register" className="register-button">
                Register
              </Link>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
